import { Component, Input, OnInit, OnDestroy, ElementRef, ChangeDetectorRef, ChangeDetectionStrategy, inject } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { NavigationService } from '@omni/services/navigation/navigation.service';
import { DeviceService } from '@omni/services/device/device.service';
import { EventsService } from '@omni/services/events/events.service';
import { AuthenticationService } from '@omni/services/authentication.service';
import { NotificationService } from '@omni/services/notification/notification.service';
import { GlobalUtilityService } from '@omni/services/global-utility.service';
import { IndSectionHeaderViewDataModel } from '@omni/models/indSectionHeaderDataModel';
import { AppointmentActivity } from '@omni/classes/activity/appointment.activity.class';
import { CaptureSignaturePopoverComponent } from '../capture-signature-modal/capture-signature-popover';
import { Subject } from 'rxjs';
import { takeUntil } from "rxjs/operators";
import { FooterService, FooterViews } from '@omni/services/footer/footer.service';
import { ActivityService } from '@omni/services/activity/activity.service';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { IoConfigurationFeatureCodes } from '@omni/classes/authentication/user.class';

/**
 * Generated class for the CaptureSignatureMeetingComponent component.
 *
 * See https://angular.io/api/core/Component for more info on Angular
 * Components.
 */
@Component({
  selector: 'capture-signature-meeting',
  templateUrl: 'capture-signature-meeting.html',
  styleUrls:['capture-signature-meeting.scss'],
  changeDetection: ChangeDetectionStrategy.Default,
})

export class CaptureSignatureMeetingComponent implements OnInit, OnDestroy {

  @Input() selectedAppointment: AppointmentActivity;
  @Input() captureSignatureMeetingEventHandler: any;
  @Input() capturedSignatureFromActivity: any;
  @Input() signatureTermsFromActivity: any;

  capturedSignature: any;
  signatureTerms: string = '';
  offlineFAEnabled = false;
  globalCustomerText: any;
  isAccessedFromMeetings = false;
  public pageTitle: string = "";
  public backButton = [{
    id: "close",
    icon: "chevron-back-outline",
    isDisabled: false,
    align: "left"
  }];
  public signatureHeaderModel: IndSectionHeaderViewDataModel;
  private readonly ngDestroy$ = new Subject<void>();
  
  readonly cdRef = inject(ChangeDetectorRef);
  readonly footerService = inject(FooterService);
  public shouldShowFooter = true;
  termBodyView: SafeHtml;
  termsHeaderModel: IndSectionHeaderViewDataModel;

  constructor(
    private readonly events: EventsService,
    public params: NavParams,
    public translate: TranslateService,
    public device: DeviceService,
    public notificationService: NotificationService,
    public utilityService: GlobalUtilityService,
    public modalCtrl: ModalController,
    private navService: NavigationService,
    private readonly el: ElementRef<HTMLElement>,
    public activityService: ActivityService,
    private readonly sanitizer: DomSanitizer,
    private readonly authenticationService: AuthenticationService,
  ) {
  }
  
  ngOnInit() {
    this.shouldShowFooter = this.footerService.shouldShowFooter();
    this.footerService.shouldShowFooter$.pipe(takeUntil(this.ngDestroy$)).subscribe(value => {
      this.shouldShowFooter = value;
      this.cdRef.markForCheck();
    });

    this.capturedSignature = this.capturedSignatureFromActivity || '';
    this.pageTitle = this.translate.instant("CAPTURE_SIGNATURE_MEETING_ACKNOWLEDGEMENT");
    this.signatureHeaderModel = {
      id:'details-header',
      title: this.translate.instant('SIGNATURE_CAP'),
      controls: []
    }

    this.events.observe("meetingCaptureSignatureSaveFailed").pipe(takeUntil(this.ngDestroy$)).subscribe(() => {
      this.capturedSignature = '';
      this.cdRef.markForCheck();
      this.cdRef.markForCheck();
    });

    try {
      const homePageElement = this.el.nativeElement.closest('page-home');
      const isFullScreen = homePageElement?.classList.contains('zen-mode-enabled');
      if (homePageElement && !isFullScreen) {
        homePageElement.classList.add('zen-mode-enabled');
        homePageElement.classList.remove('zen-mode-disabled');
        this.ngDestroy$.subscribe({complete: () => {
          homePageElement.classList.remove('zen-mode-enabled');
          homePageElement.classList.add('zen-mode-disabled');
        }});
      }
    } catch (error) {
      console.error('Error while adding zen mode', error);
    }

    if (this.capturedSignature) {
      this.signatureTerms = this.signatureTermsFromActivity || '';
      const termsContent = this.signatureTerms || null;
      this.termBodyView = termsContent 
        ? this.sanitizer.bypassSecurityTrustHtml(`<p>${termsContent}</p>`)
        : null;
    } else {
      const configuredSignatureTerms = this.authenticationService.hasIoConfigWithFeatureCode(IoConfigurationFeatureCodes.MEETING_ENABLE_SIGNATURE_TERMS) as string || '';
      const termsContent = configuredSignatureTerms ? configuredSignatureTerms : null;
      this.termBodyView = termsContent 
        ? this.sanitizer.bypassSecurityTrustHtml(`<p>${termsContent}</p>`)
        : null;
    }
  }

  ngAfterViewInit() {
    setTimeout(() => {
      this.footerService.initButtons(FooterViews.CAPTURE_SIGNATURE_MEETING);
    }, 200);
  }

  ngOnDestroy(){
    this.ngDestroy$.next();
    this.ngDestroy$.complete();
  }

  public footerHandler: (eventName: string) => void = (eventName: string) => {
    switch (eventName) {
      case "flipToMeetingDetails":
        this.goBack();
        break;
      default:
    }
  };

  async goBack() {
    await this.navService.popWithPageTracking();
    this.footerService.initButtons(FooterViews.Activities);
    this.events.publish('updateMeetingCaptureSignature');
  }

  async openSignaturePad() {
    const modal = await this.modalCtrl.create({
      component: CaptureSignaturePopoverComponent,
      componentProps: {
        skipToConfirmationPopup: true,
        from: 'CaptureSignatureMeetingComponent',
      },
      cssClass: 'signature-pad-meeting',
      showBackdrop: true,
      backdropDismiss:false
    });
      
    modal.present();
    modal.onDidDismiss().then((signData: any)=>{
      let data = signData.data;
      if (data && data.completedFlow) {
        this.captureSignatureMeetingEventHandler(data.signatureData);
        this.capturedSignature = data.signatureData;
        this.cdRef.markForCheck();
        this.cdRef.markForCheck();
      }
    });
  }
}
